import { Injectable } from '@angular/core';
import { SplashScreen } from '@capacitor/splash-screen';
import { Platform } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class SplashScreenService {
  private isNativePlatform = false;

  constructor(private platform: Platform) {
    this.checkPlatform();
  }

  private checkPlatform() {
    this.isNativePlatform = this.platform.is('capacitor');
  }

  /**
   * Hide the splash screen with proper error handling
   */
  async hideSplashScreen(): Promise<void> {
    try {
      if (this.isNativePlatform) {
        await SplashScreen.hide();
      }
    } catch (error) {
      console.error('❌ Error hiding splash screen:', error);
      // Don't throw error to prevent app from crashing
    }
  }

  /**
   * Show the splash screen (if needed for specific scenarios)
   */
  async showSplashScreen(): Promise<void> {
    try {
      if (this.isNativePlatform) {
        await SplashScreen.show();
      }
    } catch (error) {
      console.error('❌ Error showing splash screen:', error);
    }
  }

  /**
   * Check if we're running on a native platform
   */
  isNative(): boolean {
    return this.isNativePlatform;
  }

  /**
   * Get splash screen configuration optimized for full screen display
   */
  getSplashConfig() {
    return {
      launchShowDuration: 3000,
      launchAutoHide: true,
      backgroundColor: '#7205FC',
      androidSplashResourceName: 'splash',
      androidScaleType: 'FIT_XY',
      showSpinner: true,
      splashFullScreen: true,
      splashImmersive: true,
      iosSpinnerStyle: 'small',
      spinnerColor: '#ffffff',
      // Prevent iOS splash screen stretching
      iosScaleType: 'scaleAspectFit'
    };
  }

  /**
   * Initialize splash screen with proper configuration
   */
  async initializeSplashScreen(): Promise<void> {
    try {
      if (this.isNativePlatform) {
        // Ensure splash screen is visible for a minimum duration
        setTimeout(async () => {
          try {
            await this.hideSplashScreen();
          } catch (error) {
            console.error('❌ Error in delayed splash screen hide:', error);
          }
        }, 15000);
      }
    } catch (error) {
      console.error('❌ Error initializing splash screen:', error);
    }
  }
} 